export interface ILineItem {
  key: string,
  originalProductId: string,
  originalProductUrl: string,
  sku: string,
  quantity: number,
  properties: IProperties,
  countRowsVdp: number,
  scenario: E_SCENARIO,
  productVariantId: number,
};

export interface IProperties {
  _hidden: {
    originalProductId: string,
    originalProductUrl: string,
    images: string[],
    sku: string
  },
  _fields: Record<string, any>,
  _stateId: string[],
  _userId: string,
  _resources: {
    name: string,
    url: string,
    type: 'General' | 'Preview' | 'HiRes'
  }[] | any;
}

export interface ILineItemUpdate {
  key?: string,
  originalProductId?: string,
  originalProductUrl?: string,
  sku?: string,
  quantity?: number,
  images?: string[],
  fields?: Record<string, any>,
  stateId?: string[],
  userId?: string,
  resources?: any[];
  countRowsVdp?: number;
  scenario?: E_SCENARIO;
  productVariantId?: number,
}

export enum E_SCENARIO {
  VDP = 'Bulk Order',
  DEFAULT = 'Personalize'
}